<template>
  <div class="module" :id="moduleData.itemCode" style="padding-bottom: 40px;">
    <div class="module-label">
      样品信息
    </div>
    <el-form :class="{ 'cs-form': isCs }" :model="form" :rules="rules" ref="form" label-width="168px" label-position="right">
      <el-row style="padding-right: 148px;" :gutter="47">
        <!--    样品分类    -->
        <el-col :span="12" v-if="configByCode.sampleCategory">
          <el-form-item label="样品分类" class="is-required" prop="sampleCategoryCode">
            <el-select v-model="form.sampleCategoryCode" placeholder="请选择" :disabled="disabledAll" style="width: 100%;" @change="sampleCategoryChange">
              <el-option v-for="item in configByCode.sampleCategory.enums" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--    样品状态    -->
        <el-col :span="12" v-if="configByCode.sampleShape">
          <el-form-item :label="configByCode.sampleShape.attrName" class="is-required" prop="sampleShapeCode">
            <el-select v-model="form.sampleShapeCode" placeholder="请选择" :disabled="disabledAll" style="width: 100%;">
              <el-option v-for="item in configByCode.sampleShape.enums" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--    报告显示品名    -->
        <el-col :span="12" v-if="configByCode.reportShowName">
          <el-form-item :label="configByCode.reportShowName.attrName">
            <el-input :disabled="disabledAll" v-model="form.sampleName" :maxlength="configByCode.reportShowName.fillLen"></el-input>
          </el-form-item>
        </el-col>
        <!--    样品数量    -->
        <el-col :span="12" v-if="configByCode.sampleQuantity">
          <el-form-item :label="configByCode.sampleQuantity.attrName" class="is-required" prop="sampleNums">
            <el-select v-model="form.sampleNums" placeholder="请选择" :disabled="disabledAll" style="width: 100%;" @change="numChange">
              <el-option v-for="item in 10" :key="item" :label="String(item)" :value="String(item)">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="sample-list" v-if="form.sampleNums">
      <template v-for="(item, index) in sampleList">
        <SampleItem :key="index" :ref="'sample' + index" :disabledAll="disabledAll" :isOiq="isOiq" :index="index" :reportLuaCode="reportLuaCode" :sampleItem="item" :commonProps="commonProps" :required="required"></SampleItem>
      </template>
    </div>
  </div>
</template>

<script>
import {applyMixins} from "src/components/application/components/mixin";
import SampleItem from "src/components/application/components/SampleItem.vue";
import {qryBaseSample} from "src/request/apis";
export default {
  name: "Sample",
  mixins: [applyMixins],
  components: {
    SampleItem
  },
  data() {
    return {
      form: {
        sampleList: [],
        sampleCategoryCode: '',
        sampleShapeCode: '',
        sampleNums: '',
        sampleName: ''
      },
      category: [],
      shape: [],
      sampleList: [],
      basicSample: {},
      configByCode: {}
    }
  },
  computed: {
    rules() {
      return {
        sampleCategoryCode: [this.required],
        sampleShapeCode: [this.required],
        sampleNums: [this.required],
      }
    }
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const configObj = val.find(v => v.areaCode === 'Sample') || {}
        const configArr = configObj.attrs || []
        this.configByCode = this.getFormConfigByCode(configArr)
      },
      immediate: true
    },
    enumConfig: {
      handler(val) {
        if (val) {
          // const buInfo = this.buName ? this.buName.toUpperCase() + '_' : ''
          // this.category = val[`ORDER_SAMPLE.${buInfo}SAMPLE_CATEGORY`]
          // this.shape = val[`ORDER_SAMPLE.${buInfo}SAMPLE_SHAPE`]
        }
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
        if (val) {
          let form = JSON.parse(JSON.stringify(val))
          if (this.moduleData.sourceFormatJson) {
            form = this.formatByJson(val, this.moduleData.sourceFormatJson)
          }
          this.form = Object.assign(this.form, form)
          setTimeout(() => {
            this.$emit('sampleCategoryChange', {
              sampleCategory: this.form.sampleCategoryCode,
            })
          })
          if (this.form.sampleList.length && !this.isCreate) {
            const sampleList = [...this.form.sampleList]
            this.form.sampleNums = String(sampleList.length)
            const basicSample = JSON.parse(JSON.stringify(sampleList[0] || {}))
            delete basicSample.sampleNo
            this.basicSample = basicSample
            sampleList.forEach(v => {
              this.initSample(v)
            })
            this.initSample(this.basicSample, true)
            this.sampleList = JSON.parse(JSON.stringify(sampleList))
          }
        }
      },
      immediate: true
    },
    businessInfo: {
      handler(val) {
        if (val && this.isCreate) this.qryBaseSample(val.platformCode)
      },
      immediate: true
    }
  },
  created() {
  },
  methods: {
    initSample(v, isBasic) {
      v.sampleFromGoup = {}
      v.sampleFromDTOList && v.sampleFromDTOList.forEach(item => {
        item.showAttr = item.showAttr || {}
        v[item.sampleKey] = item.sampleValue
        v[item.sampleKey + 'PageRemark'] = item.remark || item.showAttr.remarkDefaultValue
        // 基础样品对象值清空
        if (isBasic) {
          v[item.sampleKey] = ''
          // remark默认值赋值
          v[item.sampleKey + 'PageRemark'] = item.showAttr.remarkDefaultValue || ''
        }
        if (!v.sampleFromGoup[item.sampleGroup]) {
          v.sampleFromGoup[item.sampleGroup] = [item.sampleKey]
        } else {
          v.sampleFromGoup[item.sampleGroup].push(item.sampleKey)
        }
      })
    },
    sampleCategoryChange(val) {
      const categoryObj = this.category.find(v => v.enumCode === val)
      if (categoryObj) this.form.sampleName = categoryObj.enumName
      this.$emit('sampleCategoryChange', {
        sampleCategory: val,
        isReset: true
      })
    },
    qryBaseSample(businessCode) {
      this.sampleLoading = true
      qryBaseSample({ businessCode }, this.host.javaUrl + (this.isCs ? '/ticOrder' : '/ticMember')).then(res => {
        this.sampleLoading = false
        this.basicSample = res.data.items[0]
        this.initSample(this.basicSample, true)
        let sample = JSON.parse(JSON.stringify(this.basicSample))
        sample.sampleNo = new Date().getTime() + String.fromCharCode(65 + Math.floor(Math.random() * 26))
        this.sampleList = [sample]
        this.form.sampleList = this.sampleList
        this.form.sampleNums = '1'
        // this.form.itemList.forEach(v => {
        //   v.sampleNoList = []
        // })
      }).catch(e => {
        this.sampleLoading = false
      })
    },
    numChange(num) {
      const len = this.sampleList.length
      if (num < len) {
        const i = len - num
        this.sampleList.splice(len - i, i)
      } else {
        const nums = num - len
        for (let i = 1; i <= nums; i++) {
          this.addSample(this.sampleList.length-1, this.basicSample)
        }
      }
    },
    addSample(index, copySample) {
      let sample = JSON.parse(JSON.stringify(copySample))
      sample.sampleNo = new Date().getTime() + String.fromCharCode(65 + Math.floor(Math.random() * 26))
      this.sampleList.splice(index+1, 0, sample)
    },
    getValidate() {
      const arr = []
      if (this.form.sampleNums) {
        const sampleList = []
        this.sampleList && this.sampleList.forEach((v, index) => {
          const key = 'sample' + index
          const data = this.$refs[key][0].getValidate()
          arr.push(data.validator)
          sampleList.push(data.sample)
        })
        this.form.sampleList = sampleList
      }
      let data = this.form
      if (this.moduleData.getFormatJson) {
        data = this.formatByJson(this.form, this.moduleData.getFormatJson)
      }
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      arr.push(new Promise(resolve => this.$refs.form.validate(resolve)))
      return arr
    },
  }
}
</script>

<style lang="scss" scoped>
.sample-list {
  background: #F5F5F5;
  padding-top: 31px;
  padding-bottom: 4px;
  ::v-deep .sample-item {
    margin-bottom: 0;
    padding-bottom: 0;
    padding-top: 0;
  }
  ::v-deep .ind-sample-title {
    left: 38px;
    top: 13px;
  }
}
</style>